import { useEffect } from "react";
import { useSocial } from "./state.js";
import { ConversationList } from "./ConversationList.js";
import { Conversation } from "./Conversation.js";
import "./chat.css";

export { jumpToMap, MessageBody, CardView } from "./MessageParts.js";

/** Chat tab: conversation list beside the open conversation on desktop, one pane at a time below 900 px (R71, D67). */
export function ChatView() {
  const channel = useSocial((s) => s.channel);
  const open = useSocial((s) => s.channelOpen);
  const openChannel = useSocial((s) => s.openChannel);

  useEffect(() => {
    void openChannel(channel);
    // Runs once: the channel is restored from the store when the tab mounts.
  }, []);

  return (
    <div className="chat chat-layout" data-open={open} data-testid="chat-view">
      <ConversationList />
      <Conversation />
    </div>
  );
}
